"use strict";function tokenFaceImg$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.tokenFaceImg$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.edu.tokenFaceImg";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.3.20"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.3.20"},_a)),exports.tokenFaceImg$=tokenFaceImg$,exports.default=tokenFaceImg$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/edu/tokenFaceImg.js
// module id = 952
// module chunks = 106